import * as types from "./actionTypes"

export const changBrand = <T extends object = {}>(
  value: T
): types.AnalysisBrandAction => ({
  type: types.CHANGE_BRAND,
  value
})

export const changCity = <T extends object = {}>(
  value: T
): types.AnalysisCityAction => ({
  type: types.CHANGE_CITY,
  value
})
